export default __webpack_public_path__ + "static/media/placeholder_dummy2016-yoga02-de.99ceac59.png";